import { HttpClient } from "../../http/HttpClient";
import ScreeningReportsRepository from "@/core/customers/repositories/ScreeningReportsRepository";
import { ScreeningReportsResponse } from "@/core/customers/entities/ScreeningReports";
import { ApiResponse } from "../../api/types/ApiResponse";
import { ApiResponseHandler } from "../../http/services/handleApiResponse/handleApiResponse";
import { screeningHistoryUrl } from "../../api/screeningEndpoints/screeningEndpoints";
import handleRequestError from "../../http/services/handleRequestError/handleRequestError";
import {
  ScreeningReportsMapper,
  ApiScreeningReport,
} from "@/core/customers/mappers/ScreeningReportsMapper";

export default class ScreeningReportsRepositoryBackend
  implements ScreeningReportsRepository
{
  constructor(private readonly httpClient: HttpClient) {}

  async getScreeningReports(
    businessKey: string
  ): Promise<ScreeningReportsResponse> {
    try {
      const url = screeningHistoryUrl(businessKey);

      const response = await this.httpClient.get<
        ApiResponse<ApiScreeningReport[]>
      >({
        url,
        withAuth: true,
      });

      const result = ApiResponseHandler.handleResponse<ApiScreeningReport[]>(
        response
      );

      if (result.success && result.data) {
        const apiResponse = {
          code: response.code,
          message: response.message,
          data: result.data,
        };

        return ScreeningReportsMapper.toDomainModel(apiResponse);
      }

      throw ApiResponseHandler.createExceptionFromResponse(response);
    } catch (error) {
      throw handleRequestError(error as ApiResponse<unknown>);
    }
  }
}

